;(function() {
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var moduleName = 'flodash';

var Flodash = function () {
  function Flodash() {
    _classCallCheck(this, Flodash);
  }

  _createClass(Flodash, null, [{
    key: 'retrieveTripType',
    value: function retrieveTripType(slices, origKey, destKey) {
      var tripType = false;

      if (slices instanceof Array && slices.length) {
        switch (slices.length) {
          case 1:
            tripType = 'OW';break;
          case 2:
            tripType = 'RT';break;
          default:
            tripType = 'MD';
        }
      }

      if (origKey && destKey && tripType === 'RT' && Flodash.isTwoSliceMD(slices, origKey, destKey)) {
        tripType = 'MD';
      }

      return tripType;
    }
  }, {
    key: 'isTwoSliceMD',
    value: function isTwoSliceMD(slices, origKey, destKey) {
      var isTwoSliceMD = false;

      if (slices instanceof Array && origKey && destKey && slices.length === 2) {
        isTwoSliceMD = slices[0][origKey] !== slices[1][destKey] || slices[1][origKey] !== slices[0][destKey];
      }

      if (slices && (slices[0][origKey] instanceof Array || slices[0][destKey] instanceof Array)) {
        isTwoSliceMD = !(0, _isEqual2.default)(slices[0][origKey], slices[1][destKey]) || !(0, _isEqual2.default)(slices[1][origKey], slices[0][destKey]);
      }

      return isTwoSliceMD;
    }
  }, {
    key: 'urlCreator',
    value: function urlCreator(input) {
      if (!input) {
        console.error('must pass an object to function'); //eslint-disable-line
        return undefined;
      }

      var validationList = [validateOrigAndDest, validatePassengerNumber];

      if (!validateObjectTypes(validationList)) {
        return undefined;
      }

      var P1_MWEB_FLIGHTS = '/smartphone/air/airapp.do';
      var DESKTOP_FLY = '/fly/#/search/';
      var MOBILE_FLY = '/m/fly/search/';
      var FLY_DEALS = '/fly/deals/express/';

      if (input.mListings) {
        var pathUrlString = objectToUrlString(input, MOBILE_FLY, false);
        pathUrlString = objectToQueryParams(input.params, pathUrlString);
        return pathUrlString;
      }

      if (input.asUrl) {
        var _pathUrlString = objectToUrlString(input, DESKTOP_FLY);
        return _pathUrlString;
      }

      if (input.dealsUrl) {
        var _pathUrlString2 = objectToUrlString(input, FLY_DEALS, false);
        _pathUrlString2 = objectToQueryParams(input.params, _pathUrlString2);
        return _pathUrlString2;
      }

      var paramUrlString = objectToQueryParams(input, P1_MWEB_FLIGHTS);
      return paramUrlString;

      // Pass in an argument of array of functions to validate
      function validateObjectTypes(validationList) {
        var validateBool = false;

        validationList.forEach(function (func) {
          if (func()) {
            validateBool = true;
          }
        });

        if (validateBool) {
          return undefined;
        }

        return true;
      }

      // Checks if `loc` is a 3 letter alphabetical string
      function validateDestination(loc) {
        if (!loc) {
          return false;
        }

        return (/^[a-zA-Z]{3}$/.test(loc)
        );
      }

      function validateOrigAndDest() {
        var slices = input.slices;

        slices.forEach(function (slice) {
          //eslint-disable-line
          if (!validateDestination(slice.origAirport) || !validateDestination(slice.destAirport)) {
            console.error('the object passed must have a string on both orig and dest ' + //eslint-disable-line
            'and must contain the 3 letter airport code');
            console.error(input); //eslint-disable-line
            return true;
          }
        });

        return undefined;
      }

      function validatePassengerNumber() {
        //eslint-disable-line
        if (input.totalPassengers && isNaN(input.totalPassengers)) {
          console.error('the object passed must have a a number on totalPassengers'); //eslint-disable-line
          console.error(input); //eslint-disable-line
          return true;
        }
      }

      function objectToQueryParams(obj, origUrl) {
        // Check for the asUrl Param
        var paramObj = {};
        for (var item in obj) {
          if (item === 'asUrl') {
            return undefined;
          }
          paramObj[item] = obj[item];
        }

        var queryParams = buildQueryString(paramObj);

        var slashAtEnd = Boolean(origUrl[origUrl.length - 1] !== '/') ? '/' : '';

        if (origUrl) {
          return '' + origUrl + slashAtEnd + '?' + queryParams;
        }

        return queryParams;

        // Builds a query string that is automatically endcoded
        // @param data which is an object
        function buildQueryString(data) {
          return Object.keys(data).map(function (key) {
            return [key, data[key]].map(encodeURIComponent).join('=');
          }).join('&');
        }
      }

      function objectToUrlString(obj, origUrl) {
        var passPassenger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var slices = obj.slices;

        // Takes a slice object and transforms it into a string
        // Ex. YVR-NYC-20161224
        var sliceStrings = slices.map(function (slice) {
          var formattedDate = updateDateString(slice.departDate);
          var origAirport = slice.origAirport.toUpperCase();
          var destAirport = slice.destAirport.toUpperCase();
          return origAirport + '-' + destAirport + '-' + formattedDate;
        });

        var concatenatedSlices = sliceStrings.join('/');
        var passengers = passPassenger ? '/' + obj.totalPassengers : '';
        var urlString = '' + origUrl + concatenatedSlices + passengers;
        return encodeURI(urlString);

        // From: 12/24/2016
        // To: 20161224
        function updateDateString(date) {
          var rearrangeDate = date.split('/');
          rearrangeDate.unshift(rearrangeDate.pop());
          return rearrangeDate.join('');
        }
      }
    }
  }]);

  return Flodash;
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  var _module$exports;

  module.exports = (_module$exports = {}, _defineProperty(_module$exports, moduleName, Flodash), _defineProperty(_module$exports, 'retrieveTripType', Flodash.retrieveTripType), _defineProperty(_module$exports, 'isTwoSliceMD', Flodash.isTwoSliceMD), _defineProperty(_module$exports, 'urlCreator', Flodash.urlCreator), _module$exports);
}
}());
